import { Component, Injector, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso, TIPOS_AVISO, TIPO_SEVERIDADE } from 'src/app/model/aviso.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { AvisoService } from './aviso.service';

@Component({
    selector: 'app-aviso-cadastro',
    templateUrl: './aviso-cadastro.component.html',
    standalone: false
})
export class AvisoCadastroComponent extends BaseEntityComponent<Aviso> implements CanComponentDeactivate{

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private tiposDeSeveridade = TIPO_SEVERIDADE;
    private tiposDeAviso = TIPOS_AVISO;
    private vc: BnConfirmDirective;
    private ocorrencias: OcorrenciaValidacaoVO[] = [];
    private usuarioLogado: Usuario;
    private anexo: File;
    private _dataDesativacao: Date;  // "transiente" para uso no template com o componente bn-datepicker 
    private permissaoEdicao: Boolean;
    public resultadoModalConfirm: string;
    @ViewChild('formAviso', {static: false}) form: NgForm;

    
    constructor(
        private modalService: BnModalMessageService,
        private permissaoService: PermissaoService,
        protected injector: Injector,
        private usuarioService: BnUsuarioService,
        private avisoService: AvisoService,
        private loadingService: BnLoadingService,
        private removerAlertasService: RemoverAlertasService,
        private fileUtils: FileUtilsService,
        private activatedRoute: ActivatedRoute) {

        super(avisoService);
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.config.rotaLista="avisos/pesquisa";
        this.config.bloquearTelaAoRecuperarModelo = true;
        this.permissaoEdicao = false;
    }
    
    ngOnInit() {
        this.usuarioService.usuario$.subscribe(usuario => this.usuarioLogado = usuario);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
            this.obterModelo().subscribe(aviso => {
                this.permissaoEdicao = resp && resp[ROLE_GESTOR_ENVIO] 
                    && (this.usuarioLogado.nome===aviso.nomeUsuarioCriacao
                        || this.usuarioLogado.login===aviso.loginUsuarioCriacao); // só o próprio publicador do aviso pode atualizá-lo
                this.preencherTela(aviso);
            });                
        });
    }

    obterModelo(): Observable<Aviso> {       
        return this.route.params.pipe(
          mergeMap((params) => {
            if (params['id']) {
                return this.avisoService.findById(params['id']);
            } else {
                const novo = new Aviso();
                novo.dataCriacao =  moment().format('YYYY-MM-DDTHH:mm:ss');
                novo.avisoAtivo = 'S';
                novo.agenteFinanceiroDestinatario = undefined;
                novo.tipo = 1; // apenas avisos do tipo Informe do administrador podem ser criados 
                novo.nomeUsuarioCriacao = this.usuarioLogado.nome;
                novo.loginUsuarioCriacao = this.usuarioLogado.login;
                super.editar();
                return of(novo);
            }
        }));
    }
    
    preencherTela(aviso: Aviso) {
        if (aviso.dataDesativacao) {
            const momentDesativacao = moment(aviso.dataDesativacao, 'YYYY-MM-DDTHH:mm:ss');
            this._dataDesativacao = momentDesativacao.toDate();
            aviso.horaDesativacao = {
                hour: momentDesativacao.hour(),
                minute: momentDesativacao.minute(),
                second: momentDesativacao.second()
            };
        } else {
            this._dataDesativacao = null;
            aviso.horaDesativacao = {
                hour: null,
                minute: null,
                second: null
            };
        }
        this.model = aviso;
    }
    
    prepararUpload(event) {
        this.anexo = (event.target as HTMLInputElement).files[0];
        this.form.control.markAsDirty();
        this.form.control.markAsTouched();
        this.model.nomeAnexo = this.anexo.name;
    }

    exportarAnexo() {
        this.avisoService.getAnexo(this.model.id).subscribe((conteudo) => {
            this.fileUtils.exportarArquivo(this.model.nomeAnexo, conteudo, FileUtilsService.APPLICATION_OCTEC);
        });
    }

    tratarDesativacao() {
        if (this._dataDesativacao) {
            this.model.nomeUsuarioDesativacao = this.usuarioLogado.nome;
        } else {
            this.model.nomeUsuarioDesativacao = ''
        }
    }

    salvar() {
    	this.loadingService.bloqueiaTela();
        this.antesDeSalvar();
        this.ocorrencias = [];
        this.removerAlertasService.removerTodos();
        
        if (this._dataDesativacao) {
            let temp: Date = this._dataDesativacao;
            this.model.horaDesativacao = {
                "hour": this.model.horaDesativacao && this.model.horaDesativacao.hour ? this.model.horaDesativacao.hour : 23,
                "minute": this.model.horaDesativacao && this.model.horaDesativacao.minute ? this.model.horaDesativacao.minute : 59,
                "second": 0,
            };            
            temp.setHours(this.model.horaDesativacao.hour);
            temp.setMinutes(this.model.horaDesativacao.minute);
            this.model.dataDesativacao = moment(temp).format('YYYY-MM-DDTHH:mm');
        } else {
            this.model.dataDesativacao = null;
        }        
        this.avisoService.save(this.getModel(), this.anexo).subscribe(
            (avisoRetornado) => {
                this.preencherTela(avisoRetornado);
                this.aposSalvar();
                this.loadingService.liberaTela();
            }, 
            (error) => {
                console.log(error);
                this.ocorrencias = this.avisoService.ocorrencias;
                this.loadingService.liberaTela();
            }
        );
    }

    voltarParaLista() {
        this.removerAlertasService.removerTodos();
        super.voltarParaLista();
    }
    
    aposSalvar() {
        this.exibeMensagemSucesso();
        this.form.control.markAsPristine();
        super.alternarEdicao();
    }
    
    exibeMensagemSucesso(): void {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Aviso criado/atualizado com sucesso.'
        });
    }

    async verificaSePodeSair(): Promise<boolean> {
        const titulo = 'Confirmação';
        const mensagem = this.model.id != null 
            ? 'Descartar alterações realizadas no aviso?' 
            : 'Descartar novo cadastro de aviso?';

        try {
            const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
            return resultadoConfimacao.value === 'ok';
        } catch (e) {
            return false;
        }
    }
      
    canDeactivate(): Promise<boolean> | boolean {
        if (!this.modoEdicao || this.form.pristine)
            return true;
         
        return this.verificaSePodeSair();
    }

}
